import React from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import useIntlMessage from '@app/hooks/use-intl-message';
import './Toggle.scss';

const Toggle = ({ onChange, isToggled, isDisabled, ariaLabelLocaleKey, titleLocaleKey, stateOnLocaleKey, stateOffLocaleKey }) => {
  const [toggleAriaLabel] = useIntlMessage(ariaLabelLocaleKey);

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!isDisabled) {
        onChange();
      }
    }
  };

  return (
    <div data-testid="toggle" className="toggle" aria-disabled={isDisabled}>
      <span className="toggle__title">
        <LocalizedText id={titleLocaleKey} />
      </span>
      <label data-testid="toggle-control" className="toggle__control">
        <input
          type="checkbox"
          checked={isToggled}
          onChange={onChange}
          disabled={isDisabled}
          aria-checked={isToggled}
          aria-label={toggleAriaLabel}
          aria-describedby="toggle-state"
          onKeyDown={handleKeyDown}
        />
        <span className="toggle__inner">
          <span className="toggle__knob" />
        </span>
      </label>
      <span id="toggle-state" className="toggle__state">
        <LocalizedText id={isToggled ? stateOnLocaleKey : stateOffLocaleKey} />
      </span>
    </div>
  );
};

Toggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  isToggled: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  ariaLabelLocaleKey: PropTypes.string.isRequired,
  titleLocaleKey: PropTypes.string.isRequired,
  stateOnLocaleKey: PropTypes.string.isRequired,
  stateOffLocaleKey: PropTypes.string.isRequired,
};

export default Toggle;
